import React, {useState, useEffect, useRef} from 'react';
import Select from "react-select";
import {findObjInArr} from "@app/utils/CommonFunctions";
import * as mainService from '@app/services/mainService';

const NhadanListComponent = ({onChange, nhadan_fk, loainhadan_fk_smaller, tableName, id_tableName, path_access, required, labelName}) => {

    const [listNhadan, setListNhadan] = useState([]);
    const isMountedRef = useRef(true);

    useEffect(() => {
        const fetchdataComponent = async () => {
            try {
              //  console.log('NhadanListComponent: Fetching nhadan data...');

                const cqtemp = await mainService.getAllNhadan({
                    path_access: path_access,
                    loainhadan_fk_smaller: loainhadan_fk_smaller,
                    tableName: tableName,
                    id_tableName: id_tableName
                });

                // Only update state if component is still mounted
                if (isMountedRef.current) {
               //     console.log('NhadanListComponent: Setting nhadan data');
                    setListNhadan(cqtemp);
                } else {
                 //   console.log('NhadanListComponent: Component unmounted, skipping state update');
                }
            } catch (error) {
              //  console.error('NhadanListComponent: Error fetching nhadan data:', error);

                // Only update state if component is still mounted
                if (isMountedRef.current) {
                    setListNhadan([]); // Set empty array on error
                }
            }
        };

        fetchdataComponent();

        // Cleanup function
        return () => {
           // console.log('NhadanListComponent: Component unmounting');
            isMountedRef.current = false;
        };
    }, [path_access, loainhadan_fk_smaller, tableName, id_tableName]); // Added proper dependencies

    return (
        <>
            <label className={required ? required : ""}>{labelName ? labelName : "Nhà đàn"}</label>
            <Select
                isClearable
                name="nhadan_fk"
                onChange={onChange}
                value={findObjInArr(listNhadan, nhadan_fk)}
                options={listNhadan}
                placeholder="Chọn nhà đàn..."
                noOptionsMessage={() => "Không có dữ liệu"}
                isLoading={listNhadan.length === 0}
            />
        </>
    );
};

export default NhadanListComponent;